// Bundler alias target for `metabase/querying/parameters/utils/query` (see
// `ias-aliases.js`). Opening a card from a dashboard builds the filter in the
// browser through `convertParametersToMbql`, bypassing the backend hook in
// `metabase.query-processor.parameters.operators/to-clause`, so range values
// are expanded here too. The upstream module is imported by relative path: the
// alias is exact-match on the `metabase/…` specifier, so this avoids a cycle.

import type Question from "metabase-lib/v1/Question";
import type { ParameterValuesMap } from "metabase-types/api";

import { convertParametersToMbql as upstreamConvertParametersToMbql } from "../../metabase/querying/parameters/utils/query";

import { expandRangeValues } from "./expand-ranges";

export * from "../../metabase/querying/parameters/utils/query";

const RANGE_PARAMETER_TYPES = new Set(["string/=", "string/!="]);

function expandRangeParameterValues(question: Question): Question {
  const parameters = question.parameters();
  const parameterValues: ParameterValuesMap = Object.fromEntries(
    parameters.map(({ id, type, value }) => {
      const expanded =
        RANGE_PARAMETER_TYPES.has(type) && Array.isArray(value)
          ? expandRangeValues(value)
          : null;
      return [id, expanded != null ? [...expanded] : value];
    }),
  );
  return question.setParameterValues(parameterValues);
}

export function convertParametersToMbql(
  question: Question,
  options: Parameters<typeof upstreamConvertParametersToMbql>[1],
): Question {
  return upstreamConvertParametersToMbql(
    expandRangeParameterValues(question),
    options,
  );
}
